import React, {  useEffect, useState } from "react";
import { Button, Input, Space, Table, Skeleton, Tabs, Form, Tag, Dropdown, Menu, Modal } from 'antd';
import * as com from '../../Common';
import { clone, cloneDeep, set} from "lodash";
import { report } from "process";
import {CaretDownOutlined} from '@ant-design/icons';
import ProspectLoans from "../ProspectLoans";

const quarterMap={
    q1: [1,2,3],
    q2: [4,5,6],
    q3: [7,8,9],
    q4: [10,11,12],
}
const boldrows=[
    "AC066","AC090","AC190","AC290","AC390",
    "AC590","AC790","AC890","AC990"
]
const rowsLabel= {
    applicationdata: [
        "AC010","AC020","AC030","AC040","AC050","AC060",
        "AC065","AC066","AC070","AC080","AC090"
    ],
    closedloandata: [
        'AC100','AC110','AC120','AC130','AC190','AC200','AC210',
        'AC220','AC290','AC300','AC310','AC320','AC390','AC400',
        'AC500','AC510','AC520','AC590','AC600','AC610','AC620',
        "AC630",
        'AC700','AC710','AC720','AC790','AC800','AC810','AC890',
        'AC900','AC910','AC920','AC930','AC940','AC990','AC1000'
    ],
    revenuedata: [
        'AC1100'
    ],
    mlodata: []
}

const closedLoanTotals = [
    "AC190","AC290","AC390","AC590","AC790","AC890","AC990"
]

const CallReportTable = (props) => {

    const applicationColumns = [
        {
          title: 'Data Points',
          dataIndex: 'data_point',
          key: 'data_point',
          width: "150px",
          render: (text, record) => (
            <div className={boldrows.includes(record.data_point)?"boldParameters":""}>{record.data_point}</div>
        )
        },
        {
            title: 'Application Pipeline',
            dataIndex: 'parameter',
            key: 'parameter',
            width: "250px",
            render: (text, record) => (
                <div className={boldrows.includes(record.data_point)?"boldParameters":""}>{record.parameter}</div>
            )
          },
        {
          title: 'Brokered',
          children: [
            {
              title: 'Amount',
              dataIndex: 'brokered_amount',
              key: 'brokered_amount',
              render: (text, record) => (
                    <div className={boldrows.includes(record.data_point)?"boldParameters nonEditable nonBorder":"nonEditable"} style={{display:"flex"}}>
                        <div style={{marginLeft:"5px"}}>$</div>
                        <div>{com.commaize(record.brokered_amount)}</div>
                    </div>
                
              )
            },
            {
              title: 'Count',
              dataIndex: 'brokered_count',
              key: 'brokered_count',
              render: (text, record) => (
                    <div className={boldrows.includes(record.data_point)?"boldParameters nonEditable nonBorder":"nonEditable"} style={{display:"flex"}}>
                        <div style={{marginLeft:"5px"}}></div>
                        <div>{record.brokered_count}</div>
                    </div>
                
              )
            },
            {
                title: 'Average',
                dataIndex: 'brokered_average',
                key: 'brokered_average',
                render: (text, record) => (
                    
                        <div className={boldrows.includes(record.data_point)?"boldParameters nonEditable nonBorder":"nonEditable"} style={{display:"flex"}}>
                            {/* <div style={{marginRight:"15px"}}>$</div> */}
                            <div style={{marginLeft:"5px"}}>{record.brokered_average === 0? " -": " $"+com.commaize(record.brokered_average)}</div>
                        </div>
                    
                  )
              },
          ],
        },
        {
          title: 'Third Party',
          children: [
            {
              title: 'Amount',
              dataIndex: 'third_party_amount',
              key: 'third_party_amount',
              render: (text, record) => (
                
                    <div className={boldrows.includes(record.data_point)?"boldParameters nonEditable nonBorder":"nonEditable"} style={{display:"flex"}}>
                        <div style={{marginLeft:"5px"}}>$</div>
                        <div>{com.commaize(record.third_party_amount)}</div>
                    </div>
                
              )
            },
            {
              title: 'Count',
              dataIndex: 'third_party_count',
              key: 'third_party_count',
              render: (text, record) => (
                
                    <div className={boldrows.includes(record.data_point)?"boldParameters nonEditable nonBorder":"nonEditable"} style={{display:"flex"}}>
                        <div style={{marginLeft:"5px"}}></div>
                        <div>{record.third_party_count}</div>
                    </div>
                
              )
            },
            {
                title: 'Average',
                dataIndex: 'third_party_average',
                key: 'third_party_average',
                render: (text, record) => (

                        <div className={boldrows.includes(record.data_point)?"boldParameters nonEditable nonBorder":"nonEditable"} style={{display:"flex"}}>
                            {/* <div style={{marginRight:"15px"}}>$</div> */}
                            <div style={{marginLeft:"5px"}}>{record.third_party_average === 0? " -": " $"+com.commaize(record.third_party_average)}</div>
                        </div>

                  )
              },
          ],
        },
      ];
    const closedloanColumns = [
        {
            title: 'Data Points',
            dataIndex: 'data_point',
            key: 'data_point',
            width: "150px",
            render: (text, record) => (
                <div className={boldrows.includes(record.data_point)?"boldParameters":""}>{record.data_point==="type"?"":` ${record.data_point}`}</div>
            ),
            onCell: (record) => {
                if (record.data_point === "type") {  // Add any datapoint values you want to merge
                  return {
                    colSpan: 1  // Merge all columns
                  };
                }
                return {};
              }
          },
          {
              title: 'Parameters',
              dataIndex: 'parameter',
              key: 'parameter',
              width: "250px",
              render: (text, record) => (
                <div className={boldrows.includes(record.data_point)?"boldParameters": record.data_point==="type"?"closedLoanTypeLabel":""}>{record.parameter}</div>
            ),
            onCell: (record) => {
                if (record.data_point === "type") {  // Add any datapoint values you want to merge
                  return {
                    colSpan: 6  // Merge all columns
                  };
                }
                return {};
            }

            },
          {
            title: 'Brokered',
            children: [
              {
                title: 'Amount',
                dataIndex: 'brokered_amount',
                key: 'brokered_amount',
                render: (text, record) => (
                    record.data_point==="type"?(<div></div>):
                    (
                        <div className={boldrows.includes(record.data_point)?"boldParameters nonEditable nonBorder":"nonEditable"} style={{display:"flex"}}>
                            <div style={{marginLeft:"5px"}}>$</div>
                            <div>{com.commaize(record.brokered_amount)}</div>
                        </div>
                    )
                ),
                onCell: (record) => {
                    if (record.data_point === "type") {  // Add any datapoint values you want to merge
                      return {
                        colSpan: 0  // Merge all columns
                      };
                    }
                    return {};
                  }
              },
              {
                title: 'Count',
                dataIndex: 'brokered_count',
                key: 'brokered_count',
                render: (text, record) => (
                    record.data_point==="type"?(<div></div>):
                   
                    (
                        <div className={boldrows.includes(record.data_point)?"boldParameters nonEditable nonBorder":"nonEditable"} style={{display:"flex"}}>
                            <div style={{marginLeft:"5px"}}></div>
                            <div>{record.brokered_count}</div>
                        </div>
                    )
                ),
                onCell: (record) => {
                    if (record.data_point === "type") {  // Add any datapoint values you want to merge
                      return {
                        colSpan: 0  // Merge all columns
                      };
                    }
                    return {};
                  }
              },
              {
                  title: 'Average',
                  dataIndex: 'brokered_average',
                  key: 'brokered_average',
                  render: (text, record) => (
                    record.data_point==="type"?(<div></div>):
                    // (!closedLoanTotals.includes(record.datapoint)&& !props.openingGeneratedReport)?(<div className="tableInputWithPrefix disabledInputColor">
                        
                    //     <Input
                    //         // defaultValue={record.brokeredamount}
                    //         style={{marginLeft:"5px"}}
                    //         value={record.brokeredaverage === 0? "-": "$ "+com.commaize(record.brokeredaverage)}
                    //         onChange={event => handleClosedLoanDataChange(event, record, "brokeredaverage")}
                    //         disabled={true}
                    //     />
                    // </div>
                    // ):
                    (
                        <div className={boldrows.includes(record.data_point)?"boldParameters nonEditable nonBorder":"nonEditable"} style={{display:"flex"}}>
                            {/* <div style={{marginRight:"15px"}}>$</div> */}
                            <div style={{marginLeft:"5px"}}>{record.brokered_average === 0? " -": " $"+com.commaize(record.brokered_average)}</div>
                        </div>
                    )
                ),
                onCell: (record) => {
                    if (record.data_point === "type") {  // Add any datapoint values you want to merge
                      return {
                        colSpan: 0  // Merge all columns
                      };
                    }
                    return {};
                  }
                },
            ],
          },
          {
            title: 'Closed-Retail Application',
            children: [
              {
                title: 'Amount',
                dataIndex: 'ndc_amount',
                key: 'ndc_amount',
                render: (text, record) => (
                    record.data_point==="type"?(<div></div>):
                    
                    (
                        <div className={boldrows.includes(record.data_point)?"boldParameters nonEditable nonBorder":"nonEditable"} style={{display:"flex"}}>
                            <div style={{marginLeft:"5px"}}>$</div>
                            <div>{com.commaize(record.ndc_amount)}</div>
                        </div>
                    )
                ),
                onCell: (record) => {
                    if (record.data_point === "type") {  // Add any datapoint values you want to merge
                      return {
                        colSpan: 0  // Merge all columns
                      };
                    }
                    return {};
                  }
              },
              {
                title: 'Count',
                dataIndex: 'ndc_count',
                key: 'ndc_count',
                render: (text, record) => (
                    record.data_point==="type"?(<div></div>):
                    
                    (
                        <div className={boldrows.includes(record.data_point)?"boldParameters nonEditable nonBorder":"nonEditable"} style={{display:"flex"}}>
                            <div style={{marginLeft:"5px"}}></div>
                            <div>{record.ndc_count}</div>
                        </div>
                    )
                ),
                onCell: (record) => {
                    if (record.data_point === "type") {  // Add any datapoint values you want to merge
                      return {
                        colSpan: 0  // Merge all columns
                      };
                    }
                    return {};
                  }
              },
              {
                  title: 'Average',
                  dataIndex: 'ndc_average',
                  key: 'ndc_average',
                  render: (text, record) => (
                    record.data_point==="type"?(<div></div>):
                    
                    (
                        <div className={boldrows.includes(record.data_point)?"boldParameters nonEditable nonBorder":"nonEditable"} style={{display:"flex"}}>
                            {/* <div style={{marginRight:"15px"}}>$</div> */}
                            <div style={{marginLeft:"5px"}}>{record.ndc_average === 0? " -": " $"+com.commaize(record.ndc_average)}</div>
                        </div>
                    )
                ),
                onCell: (record) => {
                    if (record.data_point === "type") {  // Add any datapoint values you want to merge
                      return {
                        colSpan: 0  // Merge all columns
                      };
                    }
                    return {};
                  }
                },
            ],
          },
    ]
    const revenueColumns = [
        {
            title: 'Data Points',
            dataIndex: 'data_point',
            key: 'data_point',
          },
          {
              title: 'Parameters',
              dataIndex: 'parameter',
              key: 'parameter',
            },
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
            render: (text, record) => (
               
                    <div className="nonEditable" style={{display:"flex"}}>
                        <div style={{marginLeft:"5px"}}>$</div>
                        <div>{com.commaize(record.amount)}</div>
                    </div>
                
            )
        },
    ]
    const mloColumns = [
        {
            title: 'Data Points',
            dataIndex: 'data_point',
            key: 'data_point',
            width: "150px",
        },
        {
            title: 'Parameters',
            dataIndex: 'parameter',
            key: 'parameter',
        },
        {
            title: 'MLO NMLS ID',
            dataIndex: 'nmls',
            key: 'nmls',
            render: (text, record) => (
                    <div className="nonEditable" style={{display:"flex"}}>
                        <div style={{marginLeft:"5px"}}></div>
                        <div>{record.nmls}</div>
                    </div>
            )        
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
            render: (text, record) => (
                    <div className="nonEditable" style={{display:"flex"}}>
                        <div style={{marginLeft:"5px"}}>$</div>
                        <div>{com.commaize(record.amount)}</div>
                    </div>
            )
        },
        {
            title: 'Count',
            dataIndex: 'count',
            key: 'count',
            render: (text, record) => (
                    <div className="nonEditable" style={{display:"flex"}}>
                        <div style={{marginLeft:"5px"}}></div>
                        <div>{record.count}</div>
                    </div>
            )
        },
        {
            title: 'Average',
            dataIndex: 'average',
            key: 'average',
            render: (text, record) => (
                    <div className="nonEditable" style={{display:"flex"}}>
                        {/* <div style={{marginRight:"15px"}}>$</div> */}
                        <div style={{marginLeft:"5px"}}>{record.average === 0? " -": " $"+com.commaize(record.average)}</div>
                    </div>
            )
        },
    ]
    
    
    const columnsMap = {
        application_data_points: applicationColumns,
        closed_loan_data_points: closedloanColumns,
        revenue_data_points: revenueColumns,
        mlo_data_points: mloColumns,
    }

    const dataLength = props.datatoSave.data[props.selectedState][props.selectedType]?.length || 0;
    const estimatedRowHeight = 77; // Approximate height per row
    const headerHeight = 107; // Approximate header height
    const maxHeight = 580;
    const contentHeight = dataLength * estimatedRowHeight + headerHeight;
    const needsScroll = contentHeight > maxHeight;    

    return(
        <div className="callReportTableWrapper">
            {props.selectedType !=="loanspipeline" || props.selectedType !== "revenuedata" && <div className="text-left" style={{marginLeft:"5px",marginBottom:"5px"}}>* = currently not reflected by our system</div>}
            <Table
                style={{border:"1px solid #ECECEC",borderRadius:"8px"}}
                className="callreportTable"
                columns={columnsMap[props.selectedType]}
                dataSource={props.datatoSave.data[props.selectedState][props.selectedType]}
                pagination={false}
                showSorterTooltip={false}
                scroll={{ y: needsScroll ? 580 : undefined }}
                rowClassName={(record) => boldrows.includes(record.data_point)?"totalrowsStyle":""}
            />
        </div>
    )
}

const CallReportPreview= (props) => {
    const [datatoSave, setDatatoSave] = useState(props.reportdata);
    const [loading, setLoading] = useState(false);
    const [loNameMap, setLoNameMap] = useState({});
    const [allloans, setAllloans] = useState(props.Loans);
    const [selectedState, setSelectedState] = useState(props.selectedStates[0]);
    const [selectedType, setSelectedType] = useState("application_data_points");
    const [loanDetailsData, setLoanDetailsData] = useState([])
    const [showLoanDetails, setShowLoanDetails] = useState(false)

    useEffect(() => {
        setDatatoSave(props.reportdata)
    }, [props.reportdata])

    // useEffect(() => {
    //     const result = cloneDeep(props.reportdata);
    //     if(!props.openingGeneratedReport){
    //         props.selectedStates.forEach((state) => {
    //             let data_afterApplication = applicationDataCalculation(state, datatoSave, allloans);
    //             let data_afterClosedLoan = closedloanDataCalculation(state, data_afterApplication, allloans);
    //             let data_afterRevenue = revenueDataCalculation(state, data_afterClosedLoan, allloans);
    //             let data_afterMlo = mloDataCalculation(state, data_afterRevenue, allloans);
    //             let resultdata = loansDataCalculation(state, data_afterMlo, allloans);
    //             result.data[state] = resultdata.data[state];
    //         });          
    //     }
    //     props.setCallReportDatatoSave(result)
    //     setDatatoSave(result)
    //     console.log(result)
    // }, [allloans]);

    const calculateGrossRevenue = (term,monthlypay) => {
        let revenue = 0
        if (term !== "" && monthlypay !== ""){
            revenue = parseFloat(monthlypay)* parseFloat(term) * 12
        }
        return revenue
    }
    const applicationDataCalculation =(state,initialdata,allloans)=>{
        let tempdata = cloneDeep(initialdata);

        rowsLabel.applicationdata.forEach(row => {
            tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata[row]].brokeredamount = 0
            tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata[row]].brokeredcount = 0
            tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata[row]].brokeredaverage = 0
            tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata[row]].thirdpartyamount = 0
            tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata[row]].thirdpartycount = 0
            tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata[row]].thirdpartyaverage = 0

        })

        allloans.forEach(s => {
            if (s.state === com.RuleSet.State.values[state.toUpperCase()]) {
                if (s.loanamount===""){
                    s.loanamount=0
                }
                //application in process at the beginning
                if (s.status !== "applicationwithdrawn" && 
                s.status !== "fundsreleased" && 
                s.status !== "applicationabandoned" && 
                s.status !== "applicationrejected" && 
                s.status !== "borrowerwithdrew" && 
                s.status !== "loancancelled" && 
                s.status !== "loandenied" &&
                new Date(com.timeGoToJS(s.started)) < new Date(props.selectedYear, quarterMap[props.selectedQuarter][0]-1, 1)) {
                    tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC010']].brokeredcount += 1
                    tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC010']].brokeredamount += parseInt(s.loanamount)
                }
                //application received
                if (quarterMap[props.selectedQuarter].includes(new Date(com.timeGoToJS(s.started)).getMonth()+1) &&
                new Date(com.timeGoToJS(s.started)).getFullYear() === parseInt(props.selectedYear)) {
                    tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC020']].brokeredcount += 1
                    tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC020']].brokeredamount += parseInt(s.loanamount)
                }
                //application withdrawn
                if (s.status === "applicationwithdrawn" &&
                quarterMap[props.selectedQuarter].includes(new Date(com.timeGoToJS(s.started)).getMonth()+1) &&
                new Date(com.timeGoToJS(s.started)).getFullYear() === parseInt(props.selectedYear)) {
                    tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC050']].brokeredcount += 1
                    tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC050']].brokeredamount += parseInt(s.loanamount)
                }
                //application denied
                if (s.status === "applicationdenied" &&
                quarterMap[props.selectedQuarter].includes(new Date(com.timeGoToJS(s.started)).getMonth()+1) &&
                new Date(com.timeGoToJS(s.started)).getFullYear() === parseInt(props.selectedYear)) {
                    tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC040']].brokeredcount += 1
                    tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC040']].brokeredamount += parseInt(s.loanamount)
                }

                //loans closed and funded
                if (s.status === "fundsreleased" &&
                quarterMap[props.selectedQuarter].includes(new Date(com.timeGoToJS(s.started)).getMonth()+1) &&
                new Date(com.timeGoToJS(s.started)).getFullYear() === parseInt(props.selectedYear)) {
                    tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC070']].brokeredcount += 1
                    tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC070']].brokeredamount += parseInt(s.loanamount)
                }
            }
        })
        // //net changes
        // tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC065']].brokeredcount += tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC020']].brokeredcount-tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC050']].brokeredcount-tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC040']].brokeredcount
        // tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC065']].brokeredamount += tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC020']].brokeredamount-tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC050']].brokeredamount-tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC040']].brokeredamount
        //total application pipeline
        tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC066']].brokeredcount = 
            tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC010']].brokeredcount 
                + tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC020']].brokeredcount
                - tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC030']].brokeredcount
                - tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC040']].brokeredcount
                - tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC050']].brokeredcount
                - tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC060']].brokeredcount
                - tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC062']].brokeredcount
                - tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC064']].brokeredcount
        tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC066']].brokeredamount =
            tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC010']].brokeredamount 
            + tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC020']].brokeredamount
            - tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC030']].brokeredamount
            - tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC040']].brokeredamount
            - tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC050']].brokeredamount
            - tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC060']].brokeredamount
            - tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC062']].brokeredamount
            - tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC064']].brokeredamount
            + tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC065']].brokeredamount
        //applications at the end of period
        // tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC080']].brokeredcount = tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC066']].brokeredcount - tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC070']].brokeredcount
        // tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC080']].brokeredamount = tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC066']].brokeredamount - tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC070']].brokeredamount
        //total application pipeline result
        tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC090']].brokeredcount = tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC080']].brokeredcount + tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC070']].brokeredcount
        tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC090']].brokeredamount = tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC080']].brokeredamount + tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata['AC070']].brokeredamount

        rowsLabel.applicationdata.forEach(row => {
            tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata[row]].brokeredaverage= Math.round(tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata[row]].brokeredamount/tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata[row]].brokeredcount)
            tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata[row]].thirdpartyaverage= Math.round(tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata[row]].thirdpartyamount/tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata[row]].thirdpartycount)
            if(tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata[row]].brokeredamount===0){
                tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata[row]].brokeredaverage=0
            }
            if(tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata[row]].thirdpartyamount===0){
                tempdata.data[state].applicationdata[com.callReportFieldIndex.applicationdata[row]].thirdpartyaverage=0
            }
        })
        
        return tempdata
    }
    const closedloanDataCalculation =(state,initialdata,allloans)=>{
        let tempdata = cloneDeep(initialdata);

        rowsLabel.closedloandata.forEach(row => {
            tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata[row]].brokeredamount = 0
            tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata[row]].brokeredcount = 0
            tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata[row]].brokeredaverage = 0
            tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata[row]].NDCamount = 0
            tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata[row]].NDCcount = 0
            tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata[row]].NDCaverage = 0

        })

        allloans.forEach(s => {
            if (s.state === com.RuleSet.State.values[state.toUpperCase()]) {
                if (s.loanamount===""){
                    s.loanamount=0
                }
                //conventional
                if (s.mortgageapplied === "conventional" && s.status === "fundsreleased" &&
                quarterMap[props.selectedQuarter].includes(new Date(com.timeGoToJS(s.started)).getMonth()+1) &&
                new Date(com.timeGoToJS(s.started)).getFullYear() === parseInt(props.selectedYear) ) {
                    tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata['AC100']].brokeredcount += 1
                    tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata['AC100']].brokeredamount += parseInt(s.loanamount)
                }
                if ((s.propertytype === "singlefamilydetached"|| s.propertytype==="singlefamilyattached") && s.status === "fundsreleased" && 
                quarterMap[props.selectedQuarter].includes(new Date(com.timeGoToJS(s.started)).getMonth()+1) &&
                new Date(com.timeGoToJS(s.started)).getFullYear() === parseInt(props.selectedYear)) {
                    tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata['AC200']].brokeredcount += 1
                    tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata['AC200']].brokeredamount += parseInt(s.loanamount)
                }
                if (s.propertytype === "manufacturedhome" && s.status === "fundsreleased" &&
                quarterMap[props.selectedQuarter].includes(new Date(com.timeGoToJS(s.started)).getMonth()+1) &&
                new Date(com.timeGoToJS(s.started)).getFullYear() === parseInt(props.selectedYear)) {
                    tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata['AC210']].brokeredcount += 1
                    tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata['AC210']].brokeredamount += parseInt(s.loanamount)
                }
                if (s.propertytype === "twotofourfamily" && s.status === "fundsreleased" &&
                quarterMap[props.selectedQuarter].includes(new Date(com.timeGoToJS(s.started)).getMonth()+1) &&
                new Date(com.timeGoToJS(s.started)).getFullYear() === parseInt(props.selectedYear)) {
                    tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata['AC220']].brokeredcount += 1
                    tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata['AC220']].brokeredamount += parseInt(s.loanamount)
                }
                if (s.purpose === "Purchase" && s.status === "fundsreleased" &&
                quarterMap[props.selectedQuarter].includes(new Date(com.timeGoToJS(s.started)).getMonth()+1) &&
                new Date(com.timeGoToJS(s.started)).getFullYear() === parseInt(props.selectedYear)) {
                    tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata['AC300']].brokeredcount += 1
                    tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata['AC300']].brokeredamount += parseInt(s.loanamount)
                }
                if (s.purpose === "Rate/Term Refinance" && s.status === "fundsreleased" &&
                quarterMap[props.selectedQuarter].includes(new Date(com.timeGoToJS(s.started)).getMonth()+1) &&
                new Date(com.timeGoToJS(s.started)).getFullYear() === parseInt(props.selectedYear)) {
                    tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata['AC320']].brokeredcount += 1
                    tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata['AC320']].brokeredamount += parseInt(s.loanamount)
                }
                if (s.status === "fundsreleased" && quarterMap[props.selectedQuarter].includes(new Date(com.timeGoToJS(s.started)).getMonth()+1) &&
                new Date(com.timeGoToJS(s.started)).getFullYear() === parseInt(props.selectedYear)) {
                    tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata['AC900']].brokeredcount += 1
                    tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata['AC900']].brokeredamount += parseInt(s.loanamount)
                }
            }
        })

        tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata['AC190']].brokeredamount= tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata['AC100']].brokeredamount
        tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata['AC190']].brokeredcount= tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata['AC100']].brokeredcount
        tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata['AC290']].brokeredamount= tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata['AC200']].brokeredamount + tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata['AC210']].brokeredamount + tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata['AC220']].brokeredamount
        tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata['AC290']].brokeredcount= tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata['AC200']].brokeredcount + tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata['AC210']].brokeredcount + tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata['AC220']].brokeredcount
        tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata['AC390']].brokeredamount= tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata['AC300']].brokeredamount + tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata['AC320']].brokeredamount
        tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata['AC390']].brokeredcount= tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata['AC300']].brokeredcount + tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata['AC320']].brokeredcount  
      
        rowsLabel.closedloandata.forEach(row => {
            tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata[row]].brokeredaverage= Math.round(tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata[row]].brokeredamount/tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata[row]].brokeredcount)
            tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata[row]].NDCaverage= Math.round(tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata[row]].thirdpartyamount/tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata[row]].thirdpartycount)
            if(tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata[row]].brokeredamount===0){
                tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata[row]].brokeredaverage=0
            }
            if(tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata[row]].NDCamount===0){
                tempdata.data[state].closedloandata[com.callReportFieldIndex.closedloandata[row]].NDCaverage=0
            }
        })

        return tempdata
    }
    const revenueDataCalculation =(state,initialdata,allloans)=>{
        let tempdata = cloneDeep(initialdata);
        let revenue = 0
        tempdata.data[state].revenuedata[com.callReportFieldIndex.revenuedata['AC1100']].amount = 0
        tempdata.data[state].revenuedata[com.callReportFieldIndex.revenuedata['AC1100']].count = 0
        tempdata.data[state].revenuedata[com.callReportFieldIndex.revenuedata['AC1100']].average = 0
        allloans.forEach(s => {
            if (s.state === com.RuleSet.State.values[state.toUpperCase()]) {
                if (s.status === "fundsreleased" &&
                quarterMap[props.selectedQuarter].includes(new Date(com.timeGoToJS(s.started)).getMonth()+1) &&
                new Date(com.timeGoToJS(s.started)).getFullYear() === parseInt(props.selectedYear)) {
                    revenue = calculateGrossRevenue(s.loanterm,s.monthlypay)
                    tempdata.data[state].revenuedata[com.callReportFieldIndex.revenuedata['AC1100']].amount += revenue
                    tempdata.data[state].revenuedata[com.callReportFieldIndex.revenuedata['AC1100']].count += 1
                }
            }
        })
        tempdata.data[state].revenuedata[com.callReportFieldIndex.revenuedata['AC1100']].average = Math.round(tempdata.data[state].revenuedata[com.callReportFieldIndex.revenuedata['AC1100']].amount/tempdata.data[state].revenuedata[com.callReportFieldIndex.revenuedata['AC1100']].count)
        if(tempdata.data[state].revenuedata[com.callReportFieldIndex.revenuedata['AC1100']].amount===0){
            tempdata.data[state].revenuedata[com.callReportFieldIndex.revenuedata['AC1100']].average=0
        }
        return tempdata
    }
    const mloDataCalculation =(state,initialdata,allloans)=>{
        let tempdata = cloneDeep(initialdata);
        let index=0
        let loNameMapTemp = {}
        Object.values(props.loanofficers).forEach(loanofficer => {
            loNameMapTemp[loanofficer] = index
            index += 1
        })
        loNameMapTemp["Unassigned_-"] = index
        setLoNameMap(loNameMapTemp)
        Object.entries(loNameMapTemp).forEach(([key, value]) => {
            tempdata.data[state].mlodata.push(
                {
                    datapoint: `ACMLO${value + 1}`,
                    parameters: key.split("_")[0],
                    amount: 0,
                    count: 0,
                    average: 0,
                    nmlsid: key.split("_")[1]
                }
            )
        })
        Object.keys(loNameMapTemp).forEach(lo => {
            let index = loNameMapTemp[lo];
            tempdata.data[state].mlodata[index].amount = 0
            tempdata.data[state].mlodata[index].count = 0
            tempdata.data[state].mlodata[index].average = 0
        });

        allloans.forEach(s => {
            if (s.state === com.RuleSet.State.values[state.toUpperCase()]) {
                if (quarterMap[props.selectedQuarter].includes(new Date(com.timeGoToJS(s.started)).getMonth()+1) &&
                new Date(com.timeGoToJS(s.started)).getFullYear() === parseInt(props.selectedYear)){
                    if (s.loanofficer === "Unassigned"){
                        tempdata.data[state].mlodata[loNameMapTemp["Unassigned_-"]].amount += parseInt(s.loanamount)
                        tempdata.data[state].mlodata[loNameMapTemp["Unassigned_-"]].count += 1
                    } else {
                        tempdata.data[state].mlodata[loNameMapTemp[s.loanofficer]].amount += parseInt(s.loanamount)
                        tempdata.data[state].mlodata[loNameMapTemp[s.loanofficer]].count += 1
                    }
                }
            }
        })

        Object.keys(loNameMapTemp).forEach(lo => {
            let index = loNameMapTemp[lo];
            tempdata.data[state].mlodata[index].average = Math.round(tempdata.data[state].mlodata[index].amount / tempdata.data[state].mlodata[index].count);
            if(tempdata.data[state].mlodata[index].amount === 0){
                tempdata.data[state].mlodata[index].average = 0;
            }
        });
        return tempdata
    }

    const getPurpose = (purpose, hascontract, unknownpurpose) => {
        if (purpose === "refinance") return "Rate/Term Refinance"
        if (purpose === "cashoutrefinance") return "Cash-out Refinance"
        if (purpose === "purchase") {
          if (unknownpurpose) return "TBD"
          if (!hascontract) return "Pre-qualification"
          return "Purchase"
        }
        return "TBD"
    }

    const LoansJSON = (document, index) => {
        let dt = new Date(com.timeGoToJS(document.started))
        return {
            address: document.address,
            state: document.state,
            name: document.firstname + " " + document.lastname,
            loanid: document.loanid,
            countystate: document.county+", "+ com.convertStateToAbbr(document.state),
            loanofficer: document.loanofficer,
            status: document.status,
            appintake: dt.toLocaleDateString(),
            // loid: document.lo_id,
            loanamount: document.loanamount,
            loanprice: document.price,
            loantype: document.mtype,
            mortgageapplied: document.mortgageapplied,
            amortization: document.amortization,
            mtype: document.mtype,
            loanterm: document.loanterm,
            apr: document.apr,
            baserate: document.baserate,
            monthlypay: document.monthlypay,
            lenderfee: document.lenderfee,
            propertytype: document.propertytype,
            occupancy: document.occupancy,
            purpose: getPurpose(document.purpose, document.hascontract, document.unknownpurpose),
        }
    }

    const loansDataCalculation = (state,initialdata,allloans) => {
        let tempdata = cloneDeep(initialdata);
        let temploans = cloneDeep(allloans);
        let filteredloans = temploans.map(LoansJSON).filter(s => {
            return(
                s.state.includes(com.RuleSet.State.values[state.toUpperCase()]) &&
                quarterMap[props.selectedQuarter].includes(new Date(s.appintake).getMonth()+1) &&
                new Date(s.appintake).getFullYear() === parseInt(props.selectedYear)
            )
        })
        //records of filteredloans by appintake date descending order
        filteredloans.sort((a, b) => new Date(a.appintake) - new Date(b.appintake))
        tempdata.data[state]["loanspipeline"] = filteredloans;
        
        return tempdata
    }

    const getMenuItems = () => {
        return props.selectedStates.map(state => {
            return {
                key: state,
                label: com.RuleSet.State.values[state.toUpperCase()].toUpperCase(),
                children: [
                    {
                        key: `${state}-application_data_points`,
                        label: "Application Data",
                    },
                    {
                        key: `${state}-closed_loan_data_points`,
                        label: "Closed Loan Data",
                    },
                    {
                        key: `${state}-revenue_data_points`,
                        label: "Revenue Data",
                    },
                    {
                        key: `${state}-mlo_data_points`,
                        label: "MLO Data",
                    },
                ]
            }
        })
    }
    
    return(
        <div className="callReportContentWrapper">
            <Menu 
                style={{width: "250px", height: "100%", overflowY: "auto"}}
                defaultSelectedKeys={[props.selectedStates[0]+"-application_data_points"]}
                defaultOpenKeys={[props.selectedStates[0]]}
                mode="inline"
                items={getMenuItems()}
                onClick={(e) => {
                    setSelectedState(e.key.split("-")[0])
                    setSelectedType(e.key.split("-")[1])
                }}
            />
            <CallReportTable
                {...props}
                selectedQuarter={props.selectedQuarter}
                selectedYear={props.selectedYear}
                loMap={loNameMap}
                allloans={allloans}
                setAllloans={setAllloans}
                datatoSave={datatoSave}
                setDatatoSave={setDatatoSave}
                selectedState={selectedState}
                selectedType={selectedType}
                setCallReportDatatoSave={props.setCallReportDatatoSave}
                setLoanDetailsData={setLoanDetailsData}
                setShowLoanDetails={setShowLoanDetails}
                setReportSaved={props.setReportSaved}
                setNewChange={props.setNewChange}
            />
        </div>
    )
}

export default CallReportPreview;